import { render, staticRenderFns } from "./StateBadge.vue?vue&type=template&id=32679eb8&scoped=true"
import script from "./StateBadge.vue?vue&type=script&lang=ts"
export * from "./StateBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32679eb8",
  null
  
)

export default component.exports